import { render, staticRenderFns } from "./remoteUpBatchModal.vue?vue&type=template&id=1c01890c&scoped=true"
import script from "./remoteUpBatchModal.vue?vue&type=script&lang=js"
export * from "./remoteUpBatchModal.vue?vue&type=script&lang=js"
import style0 from "./remoteUpBatchModal.vue?vue&type=style&index=0&id=1c01890c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01890c",
  null
  
)

export default component.exports